import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgSmiley = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.5 12a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M7.967 13.213a.75.75 0 1 0-1.44.42 5.702 5.702 0 0 0 10.946 0 .75.75 0 1 0-1.44-.42 4.202 4.202 0 0 1-8.066 0m.831-3.31a.394.394 0 1 0 0-.788.394.394 0 0 0 0 .789M7.692 9.51a1.106 1.106 0 1 1 2.212 0 1.106 1.106 0 0 1-2.212 0m7.904 0a.394.394 0 1 1-.788 0 .394.394 0 0 1 .788 0m-.394-1.106a1.106 1.106 0 1 0 0 2.211 1.106 1.106 0 0 0 0-2.211"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgSmiley;
